import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=551b6656&scoped=true&lang=html&"
var script = {}
import style0 from "./Download.vue?vue&type=style&index=0&id=551b6656&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551b6656",
  null
  
)

export default component.exports